export default function WorkflowOverview() {
  return (
    <section id="overview" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              什么是文档工作流程？
            </h2>
            <div className="space-y-4 text-gray-600 leading-relaxed">
              <p>
                文档工作流程是一种管理文档在组织内流通方式的系统。有效的文档工作流程有助于确保所有必要人员均可通过一个精简框架访问和控制文档，从而帮助实现安全治理。
              </p>
              <p>
                通过采用精心规划的文档工作流，可以帮助员工快速获取所需文档以最大化工作效率，同时限制相应用户的访问权限，确保数据安全和合规性。
              </p>
              <p>
                我们的咨询服务帮助企业建立完善的文档管理体系，从文档创建、审批、存储到归档的全生命周期管理，实现流程自动化和智能化。
              </p>
            </div>
          </div>
          
          <div className="grid grid-cols-2 gap-6">
            <div className="bg-gradient-to-br from-teal-50 to-teal-100/50 p-8 rounded-2xl">
              <div className="w-14 h-14 bg-teal-500 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-file-text-line text-2xl text-white"></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">10,000+</div>
              <div className="text-sm text-gray-600">文档处理量提升</div>
            </div>
            
            <div className="bg-gradient-to-br from-blue-50 to-blue-100/50 p-8 rounded-2xl mt-8">
              <div className="w-14 h-14 bg-blue-500 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-time-line text-2xl text-white"></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">70%</div>
              <div className="text-sm text-gray-600">时间成本节省</div>
            </div>
            
            <div className="bg-gradient-to-br from-purple-50 to-purple-100/50 p-8 rounded-2xl">
              <div className="w-14 h-14 bg-purple-500 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">99.9%</div>
              <div className="text-sm text-gray-600">安全合规率</div>
            </div>
            
            <div className="bg-gradient-to-br from-orange-50 to-orange-100/50 p-8 rounded-2xl mt-8">
              <div className="w-14 h-14 bg-orange-500 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-team-line text-2xl text-white"></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">500+</div>
              <div className="text-sm text-gray-600">成功案例</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
